export enum Merkzeichen {
  G = 'G',
  B = 'B',
  AG = 'AG',
  H = 'H',
  RF = 'RF',
  BL = 'BL',
  GL = 'GL',
  TBL = 'TBL',
  KL = 'KL',
  VB = 'VB',
  EB = 'EB',
}

export type Behinderungsgrad = 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;
export type PflegeGrad = 1 | 2 | 3 | 4 | 5;

export const behinderungsGradToLabel: Map<Behinderungsgrad, string> = new Map([
  [20, '20'],
  [30, '30'],
  [40, '40'],
  [50, '50'],
  [60, '60'],
  [70, '70'],
  [80, '80'],
  [90, '90'],
  [100, '100'],
]);

export const merkzeichenToText: Map<Merkzeichen, string> = new Map([
  [Merkzeichen.G, 'G - erhebliche Gehbehinderung'],
  [Merkzeichen.B, 'B - Begleitperson'],
  [Merkzeichen.AG, 'aG - außergewöhnliche Gehbehinderung'],
  [Merkzeichen.H, 'H - Hilflosigkeit'],
  [Merkzeichen.RF, 'RF - Ermäßigung des Rundfunkbeitrags'],
  [Merkzeichen.BL, 'Bl - Blindheit'],
  [Merkzeichen.GL, 'Gl - Gehörlosigkeit'],
  [Merkzeichen.TBL, 'TBl - Taubblindheit'],
  [Merkzeichen.KL, '1. KL'],
  [Merkzeichen.VB, 'VB'],
  [Merkzeichen.EB, 'EB'],
]);

export const pflegegradDropdownOptions: { label: string; value: number }[] = Array.from(
  new Array(5).keys(),
).map((i) => ({
  value: i + 1,
  label: (i + 1).toString(),
}));
